module.exports = __webpack_public_path__ + "media/images/back_green-a9e0c4c0942f847ae32203a685601118.gif";